import React from 'react';
export function Footer() {
  return <footer className="bg-[#0f0d09] border-t border-[#7c3aed]/20 py-8 px-4 text-center" data-id="element-165">
      <div className="max-w-3xl mx-auto" data-id="element-166">
        <div className="inline-flex items-center gap-2 text-[#7c3aed] font-black text-xl mb-4" data-id="element-167">
          <span data-id="element-168">🎵</span> TU MANUAL DIGITAL™
        </div>

        <p className="text-[#e7dfce] mb-6 max-w-md mx-auto font-medium" data-id="element-169">
          El sistema de terapia vibracional N°1 para el argentino moderno.
        </p>

        <div className="flex flex-col items-center gap-2 text-sm text-[#6b6358] mb-8 font-bold" data-id="element-170">
          <a href="mailto:soporte.tumanualdigital@gmail.com" className="hover:text-[#7c3aed] transition-colors" data-id="element-171">
            📧 soporte.tumanualdigital@gmail.com
          </a>
          <a href="https://www.tumanualdigital.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#7c3aed] transition-colors" data-id="element-172">
            🌐 www.tumanualdigital.com
          </a>
        </div>

        <div className="text-xs text-[#6b6358] space-y-2 font-medium" data-id="element-173">
          <p data-id="element-174">© Tu Manual Digital™ · Todos los derechos reservados</p>
          <p className="italic" data-id="element-175">
            "Tu sistema nervioso merece herramientas tan rápidas como el mundo
            que lo agota." 🎵
          </p>
        </div>
      </div>
    </footer>;
}